import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import './PageToolsBar.scss';

const PageToolsBar = ({ className = '', searchValue = '', updateSearchValue = () => {} }) => {
	return (
		<div className={classNames('PageToolsBar', className)}>
			<input value={searchValue} onChange={updateSearchValue} />
		</div>
	);
};

PageToolsBar.propTypes = {
	className: PropTypes.string,
	searchValue: PropTypes.string,
	updateSearchValue: PropTypes.func,
};

export default PageToolsBar;
